import { ReactNode, useEffect, useRef, useState } from "react";
import Clipboard from "clipboard";
import { Button, Tooltip } from "antd";
import { CustomTooltip } from "./CustomTooltip";

export const CopyButton: React.FC<{
  text: string;
  type?: "default" | "primary" | "dashed" | "link" | "text";
  label?: ReactNode | string;
  icon: ReactNode;
  clickedIcon: ReactNode;
  shape?: "default" | "circle" | "round";
  style?: React.CSSProperties;
  disabled?: boolean;
  tooltip?: string;
}> = ({ type, text, label, icon, clickedIcon, style, disabled, tooltip }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (buttonRef.current) {
      const clipboard = new Clipboard(buttonRef.current, {
        text: () => `${text}`,
      });

      clipboard.on("success", () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000); // Reset icon after 2 seconds
      });

      clipboard.on("error", () => {
        console.log("error copying to clipboard");
      });

      return () => {
        clipboard.destroy();
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {tooltip ? (
        <CustomTooltip content={tooltip} placement="top">
          <Button
            icon={copied ? clickedIcon : icon}
            type={type || "default"}
            style={style}
            ref={buttonRef}
            size="small"
            disabled={disabled}
          >
            {label}
          </Button>
        </CustomTooltip>
      ) : (
        <Button
          icon={copied ? clickedIcon : icon}
          type={type || "default"}
          style={style}
          ref={buttonRef}
          size="small"
          disabled={disabled}
        >
          {label}
        </Button>
      )}
    </>
  );
};
